
export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/ec2b3a7da5596648e2bc3679a00e2df5.jpg)'
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      
      <div className="relative z-10 w-full px-8 lg:px-16 py-32">
        <div className="max-w-4xl">
          <h1 className="text-7xl font-bold text-white leading-tight mb-8">
            Innovative iOS Solutions
          </h1>
          <p className="text-2xl text-gray-200 font-light leading-relaxed max-w-2xl">
            Enhancing mobile security and performance through cutting-edge applications designed for the modern iOS ecosystem
          </p>
        </div>
      </div>
    </section>
  );
}
